import { PERMISSIONS } from './roleUtils';

/** A sidebar queue for one seeded workflow, separate from Tabins Enquiries. */
export interface WorkflowQueue {
  path: string;
  permission: string;
  title: string;
  workflowName: string;
  /** Lower case, as in "Register a new loan enquiry". */
  itemName: string;
  /** This team sees every item in the workflow, not only work assigned to them. */
  oversightTeam: string;
}

export const WORKFLOW_QUEUES: WorkflowQueue[] = [
  {
    path: '/loan-enquiries',
    permission: PERMISSIONS.loanEnquiriesView,
    title: 'Loan Enquiries',
    workflowName: 'Loan Application Processing',
    itemName: 'loan enquiry',
    oversightTeam: 'Credit Manager',
  },
  {
    path: '/retail-enquiries',
    permission: PERMISSIONS.retailEnquiriesView,
    title: 'Retail Enquiries',
    workflowName: 'Inventory Replenishment',
    itemName: 'retail enquiry',
    oversightTeam: 'Purchasing Manager',
  },
  {
    path: '/insurance-enquiries',
    permission: PERMISSIONS.insuranceEnquiriesView,
    title: 'Insurance Enquiries',
    workflowName: 'Claim Processing',
    itemName: 'insurance enquiry',
    oversightTeam: 'Claims Manager',
  },
];

/** True when this team follows every item on that workflow's enquiry page. */
export const isQueueOversight = (queue: WorkflowQueue, teamName?: string) =>
  Boolean(teamName && queue.oversightTeam.trim().toLowerCase() === teamName.trim().toLowerCase());

/** Opening a task is allowed from Enquiries or any of the three workflow queues. */
export const TASK_VIEW_PERMISSIONS = [
  PERMISSIONS.enquiryView,
  ...WORKFLOW_QUEUES.map((queue) => queue.permission),
];
